import React from 'react';
import EstheticConfirmUserTemplate from '../../components_membership_hotel/template/esthetic/estheticConfirmUserTemplate';
import { getReserveList } from '../../const';
import image_base from '../../resources/image/HakoneGardenTerrace.jpg';
import common from "../../resources/js/common/common";

class EstheticConfirmUser extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // ゴルフ確認モーダル
            membershipPopup: false,
            popupDataList: [],
            popupMessage: "",
            popupMode: "",
            popupTitle: "",
            locationInfo: props.location.state && props.location.state.locationInfo ? props.location.state.locationInfo : false,
            loginFlg: false,
            shisetsuCd: "",
            esthrticCd: ""
        };
    };

    render() {
        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            },
        }

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId, importedFlg: true }, afterGetReserveList);
        }

        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
        }

        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // popupMode変更
        const setPopupMode = (mode) => this.setState({ popupMode: mode })

        // popUpMessage変更
        const setPopupMessage = (message) => this.setState({ popupMessage: message })

        // URLパラメータ用情報設定
        const setLinkParameter = (shisetsuCd, estheticCd) => this.setState({ shisetsuCd: shisetsuCd, estheticCd: estheticCd })

        // ポップアップ表示情報設定
        const setPopupData = (title, mode, data) => {
            this.setState({
                membershipPopup: !this.state.membershipPopup,
                popupTitle: title,
                popupMode: mode,
                popupData: data
            });
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipPopup: false }); };

        // 予約確認ポップアップ表示制御用ログインフラグ設定
        const setLoginFlg = (loginFlg) => this.setState({ loginFlg: loginFlg });

        return (
            <div style={style.base}>
                <EstheticConfirmUserTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    setPopupMode={setPopupMode}
                    setPopupMessage={setPopupMessage}
                    setPopupData={setPopupData}
                    setLoginFlg={setLoginFlg}
                    setLinkParameter={setLinkParameter}
                />
            </div>
        )
    }
}
export default EstheticConfirmUser;